import "flowbite";
import useTenFlashProducts from "hook/useTenFlashProducts";
import useFlashSaleData from "hook/useFlashSaleData";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import newIcon from "images/flash-sale.png";
import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { TbCurrencyTaka } from "react-icons/tb";
import "swiper/css";
import "swiper/css/navigation";
import { FaCartPlus } from "react-icons/fa";
import OrderNowModal from "models/orderNowModal";
import { useSettings } from "context/SettingsContext";
import { t } from "context/translations";
import { getCartItems, setCartItems } from "utils/cartStorage";
import { assetUrl } from "utils/api";
const FlashSale = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const { flashSaleData, loading } = useFlashSaleData();
  const { allProducts, loading1 } = useTenFlashProducts();
  const [orderModalOpen, setOrderModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const slidesPerView = 5,
    slides =
      allProducts.length <= slidesPerView ? [...allProducts] : allProducts;

  // const { flashSaleData, loading, errorFooter } = useFlashSaleData();
  const [timeLeft, setTimeLeft] = useState(0);
  const { theme, language } = useSettings();
  const isDark = theme === "dark";

  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    if (flashSaleData) {
      if (flashSaleData.available === false) {
        setIsVisible(false);
        return;
      }
      setIsVisible(true);
      setTimeLeft(Math.floor(flashSaleData.remaining_seconds));
    }
  }, [flashSaleData]);

  useEffect(() => {
    if (timeLeft <= 0) {
      setIsVisible(false);
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (totalSeconds) => {
    totalSeconds = Math.max(0, Math.floor(totalSeconds));
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return { days, hours, minutes, seconds };
  };

  const { days, hours, minutes, seconds } = formatTime(timeLeft || 0);

  // Skeleton slide
  const SlideSkeleton = () => (
      <div
          className={`flex-shrink-0 w-[225px] md:w-[200px] max-md:basis-[47%] rounded-[10px] overflow-hidden
  ${isDark ? "bg-slate-800" : "bg-white"}`}
      >
        {/* Image */}
        <div
            className={`w-full aspect-[4/5] relative rounded-t-[10px] overflow-hidden
    ${isDark ? "bg-slate-700" : "bg-gray-300"}`}
        >
          <div
              className={`absolute inset-0 animate-shimmer
      ${
                  isDark
                      ? "bg-gradient-to-r from-slate-700 via-slate-600 to-slate-700"
                      : "bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300"
              }`}
          />
        </div>

        {/* Text */}
        <div className="p-2 flex flex-col gap-2">

          {/* Title */}
          <div
              className={`h-4 w-3/4 rounded relative overflow-hidden
      ${isDark ? "bg-slate-700" : "bg-gray-300"}`}
          >
            <div
                className={`absolute inset-0 animate-shimmer
        ${
                    isDark
                        ? "bg-gradient-to-r from-slate-700 via-slate-600 to-slate-700"
                        : "bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300"
                }`}
            />
          </div>

          {/* Price */}
          <div
              className={`h-4 w-1/2 rounded relative overflow-hidden
      ${isDark ? "bg-slate-700" : "bg-gray-300"}`}
          >
            <div
                className={`absolute inset-0 animate-shimmer
        ${
                    isDark
                        ? "bg-gradient-to-r from-slate-700 via-slate-600 to-slate-700"
                        : "bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300"
                }`}
            />
          </div>

        </div>
      </div>
  );
  if (loading1) {
    return (
      <div className="relative md:max-w-7xl mx-auto px-4 sm:px-4 2xl:px-0 lg:px-8 pt-4 md:pb-4 pb-0">
        <div className="relative flex overflow-x-auto gap-5 pb-5 hide-scrollbar">
          {Array.from({ length: 6 }).map((_, i) => (
            <SlideSkeleton key={i} />
          ))}
          <style>{`.hide-scrollbar::-webkit-scrollbar { display: none; }`}</style>
        </div>
      </div>
    );
  }

  if (!loading1 && (!allProducts || allProducts.length === 0)) {
    return null;
  }

  return (
    <div className=" relative md:max-w-7xl mx-auto sm:px-4 2xl:px-0 lg:px-8 pt-0 md-pt-4 md:pb-4 pb-0">
      <div className=" px-4 ">
        <Link to="/hotOffer" className="block">
          <div className="flex items-center justify-between gap-2 py-4 sm:py-5">
            {/* Left Side */}
            <div className="flex items-center gap-2 sm:gap-3 min-w-0">
              <img
                src={newIcon}
                alt="icon"
                className="w-5 h-5 sm:w-7 sm:h-7 md:w-8 md:h-8 flex-shrink-0"
              />

              <h2 className="sm:text-xl md:text-2xl font-bold bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-500 bg-clip-text text-transparent tracking-wide truncate">
                {t("flashSale", language)}
              </h2>
            </div>

            {/* Right Side Timer */}
            <div
              className="px-2.5 sm:px-4 py-1 rounded-md sm:rounded-lg
      bg-gradient-to-r from-red-500 to-orange-400 backdrop-blur shadow-sm flex-shrink-0"
            >
              <p
                className="text-[11px] sm:text-sm md:text-base font-bold text-white
        tabular-nums whitespace-nowrap"
              >
                {String(days).padStart(2, "0")}d
                <span className="mx-1 text-gray-400">|</span>
                {String(hours).padStart(2, "0")}h
                <span className="mx-1 text-gray-400">|</span>
                {String(minutes).padStart(2, "0")}m
                <span className="mx-1 text-gray-400">|</span>
                {String(seconds).padStart(2, "0")}s
              </p>
            </div>
          </div>
        </Link>
        {loading ? (
          <Swiper
            modules={[Autoplay]}
            slidesPerView={slidesPerView}
            spaceBetween={16}
            loop
            speed={800}
            autoplay={{ delay: 1500, disableOnInteraction: false }}
          >
            {Array.from({ length: slidesPerView }).map((_, i) => (
              <SwiperSlide key={i}>
                <SlideSkeleton />
              </SwiperSlide>
            ))}
          </Swiper>
        ) : allProducts.length === 0 ? (
          <div className="text-center py-10 my-5">
            <p className="font-semibold"> {t("noProductFound", language)}</p>
          </div>
        ) : (
          <>
            <Swiper
              modules={[Autoplay, Navigation]}
              loop
              speed={800}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }}
              onBeforeInit={(swiper) => {
                swiper.params.navigation.prevEl = prevRef.current;
                swiper.params.navigation.nextEl = nextRef.current;
              }}
              spaceBetween={4}
              breakpoints={{
                320: { slidesPerView: 2 },
                640: { slidesPerView: 3 },
                768: { slidesPerView: 4 },
                1024: { slidesPerView },
              }}
              className="pb-10"
            >
              {slides.map((item, index) => {
                const isOutOfStock = item.quantity === 0;
                const firstVariant = item.variants?.[0] || {};
                const firstImage = firstVariant.images?.[0]?.thumb || "";
                const selectedTitle = firstVariant.title || "-";
                const selectedPrice = firstVariant.flashPrice || 0;
                const selectedDiscount = firstVariant.discount || 0;
                const originalPrice = selectedDiscount || 0;
                const flashPrice = selectedPrice || 0;
                const discountPercent =
                  originalPrice > 0
                    ? Math.ceil(
                        ((originalPrice - flashPrice) / originalPrice) * 100,
                      )
                    : 0;

                return (
                  <SwiperSlide key={`${item.id}-${index}`}>
                    <div
                      className={`relative mb-3 border ease-in-out transform hover:border-lightBgColor flex flex-col flex-shrink-0 lg:w-[225px] md:w-[200px] max-md:basis-[47%] bg-white rounded-[10px] overflow-hidden transition-transform duration-200 ${
                        isOutOfStock ? "cursor-not-allowed opacity-40" : ""
                      }`}
                    >
                      {isOutOfStock && (
                        <div className="absolute inset-0 flex items-center justify-center z-20">
                          <div className="bg-red-600 text-white text-2xl font-bold px-3 py-2 rounded-lg shadow-lg">
                            {t("stockOut", language)}
                          </div>
                        </div>
                      )}

                      <Link to={`/details/${item.catalogue}/${item.item_id}`}>
                        {/* <div className="relative group aspect-product-desktop w-full overflow-hidden">
                          <img
                            src={assetUrl(firstImage)}
                            alt={selectedTitle}
                            className="transition-transform duration-1000 ease-in-out transform w-full group-hover:scale-105 cursor-pointer rounded-t-[10px]"
                          />
                        </div> */}
                        <div className="relative group aspect-product-desktop w-full overflow-hidden">
                          {/* Discount Ribbon */}
                          {/* {discountPercent > 0 && (
                            <div className="absolute top-3 -left-10 rotate-[-45deg] bg-gradient-to-r from-orange-500 via-orange-600 to-red-600 text-white text-xs font-bold px-12 py-1 shadow-lg z-10">
                              {discountPercent}% OFF
                            </div>
                          )} */}

                          <img
                            src={assetUrl(firstImage)}
                            alt={selectedTitle}
                            className="transition-transform duration-1000 ease-in-out transform w-full group-hover:scale-105 cursor-pointer rounded-t-[10px]"
                          />
                          <div className="absolute top-2 left-2">
                            {discountPercent > 0 && (
                              <div className="px-2 md:h-5 h-6 flex items-center justify-center rounded-xl bg-gradient-to-r from-orange-500 to-red-500 text-white font-semibold text-xs">
                                {discountPercent}% OFF
                              </div>
                            )}
                          </div>
                        </div>
                      </Link>

                      <div className="md:px-3 p-2 flex flex-col flex-grow">
                        <div className="text-black px-1 hover:text-[#222836] hover:opacity-60 tracking-wide mb-1 text-sm whitespace-nowrap overflow-hidden truncate">
                          {selectedTitle}
                        </div>

                        <div className="flex justify-between items-center pb-2 text-sm md:text-base px-1">
                          <div className="flex">
                            <div className="flex text-backgroundColor items-center">
                              <p className="font-bold text-darkBgColor">
                                {selectedPrice}
                              </p>
                              <TbCurrencyTaka className="font-semibold text-darkBgColor" />
                            </div>
                            <div className="relative inline-flex items-center text-gray-400 text-xs md:text-sm ml-1">
                              <span className="flex items-center">
                                <p>{selectedDiscount}</p>
                                <TbCurrencyTaka className="font-semibold" />
                              </span>
                              <div className="absolute left-0 right-0 top-1/2 h-[.5px] bg-gray-400"></div>
                            </div>
                          </div>
                        </div>

                        {/* Add to Cart Button */}
                        {!isOutOfStock && (
                          <div className="flex gap-2 my-1 mt-auto px-1">
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                setSelectedItem(item);
                                setOrderModalOpen(true);
                              }}
                              className="flex-1 text-white text-sm md:text-base bg-darkBgColor border border-darkBgColor rounded-md px-4 py-1 md:font-bold font-semibold flex justify-center items-center"
                            >
                              {t("order", language)}
                            </button>
                            <button
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();

                                const existingItems = getCartItems();
                                const key = item.item_id || item.title;
                                const existingIndex = existingItems.findIndex(
                                  (p) => (p.item_id || p.title) === key,
                                );

                                const firstVariant = item.variants?.[0] || {};
                                const colorArray =
                                  item.color?.split(",").map((s) => s.trim()) ||
                                  [];
                                const sizeArray =
                                  item.size?.split(",").map((s) => s.trim()) ||
                                  [];
                                const selectedColor = colorArray[0] || "";
                                const selectedSize = sizeArray[0] || "";
                                const selectedTitle = firstVariant.title || "";
                                const selectedPrice =
                                  firstVariant.flashPrice || 0;

                                if (existingIndex !== -1) {
                                  existingItems[existingIndex] = {
                                    ...existingItems[existingIndex],
                                    quantity:
                                      (existingItems[existingIndex].quantity ||
                                        1) + 1,
                                    selectedColor,
                                    selectedSize,
                                    selectedTitle,
                                    selectedPrice,
                                  };
                                } else {
                                  existingItems.push({
                                    ...item,
                                    quantity: 1,
                                    selectedColor,
                                    selectedSize,
                                    selectedTitle,
                                    selectedPrice,
                                    selectedVariant: firstVariant,
                                  });
                                }
                                setCartItems(existingItems);
                                toast.success(t("addedToCart", language));
                              }}
                              className=" text-[#FF4747] py-1"
                            >
                              <span className="group-hover:hidden md:text-base text-sm">
                                <FaCartPlus />
                              </span>
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}

              {/* Navigation buttons */}
              <button
                ref={prevRef}
                className="absolute top-1/2 left-0 z-10 -translate-y-1/2 text-darkBgColor hover:bg-white/50 bg-white w-9 h-9 rounded-full flex items-center justify-center shadow border"
              >
                ❮
              </button>
              <button
                ref={nextRef}
                className="absolute top-1/2 right-0 z-10 -translate-y-1/2 text-darkBgColor hover:bg-white/50 bg-white w-9 h-9 rounded-full flex items-center justify-center shadow border"
              >
                ❯
              </button>
            </Swiper>
          </>
        )}
      </div>
      <OrderNowModal
        isOpen={orderModalOpen}
        item={selectedItem}
        onClose={() => setOrderModalOpen(false)}
      />

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};
export default FlashSale;
